"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridSelected = void 0;
var React = __importStar(require("react"));
var Grid_1 = require("./Grid");
exports.GridSelected = function (props) {
    var _a = props.grid, grid = _a === void 0 ? 5 : _a, title = props.title, items = props.items, onRemove = props.onRemove, children = props.children;
    return (React.createElement(React.Fragment, null,
        React.createElement("h4", { className: "text-center mt-3 font-weight-bold" },
            "Selected ",
            title),
        React.createElement("div", null, (items === null || items === void 0 ? void 0 : items.length) ? (React.createElement("div", { className: "grid grid-horizontal" }, items === null || items === void 0 ? void 0 : items.map(function (i) {
            var _a, _b, _c, _d, _e, _f, _g;
            return (React.createElement("div", { className: "grid-item", key: i._id },
                React.createElement("div", { className: "d-inline-block position-relative" },
                    React.createElement("span", { onClick: function () { return onRemove === null || onRemove === void 0 ? void 0 : onRemove(i); }, className: "remove" },
                        React.createElement("i", { className: "fa-solid fa-circle-xmark" })),
                    React.createElement("img", { src: i === null || i === void 0 ? void 0 : i.itemImgUrl, alt: Grid_1.truncateText((_a = i === null || i === void 0 ? void 0 : i.itemName) !== null && _a !== void 0 ? _a : "", i === null || i === void 0 ? void 0 : i.itemFileExt) })),
                React.createElement("p", { className: "text-center grid-item-name", title: (_d = (_b = i === null || i === void 0 ? void 0 : i.itemName) === null || _b === void 0 ? void 0 : _b.replace("." + ((_c = i === null || i === void 0 ? void 0 : i.itemFileExt) !== null && _c !== void 0 ? _c : ""), "")) !== null && _d !== void 0 ? _d : "" }, Grid_1.truncateText((_g = (_e = i === null || i === void 0 ? void 0 : i.itemName) === null || _e === void 0 ? void 0 : _e.replace("." + ((_f = i === null || i === void 0 ? void 0 : i.itemFileExt) !== null && _f !== void 0 ? _f : ""), "")) !== null && _g !== void 0 ? _g : "", ""))));
        }))) : (children))));
};
